import { render } from "./FontSpecimenVariableElement.vue?vue&type=template&id=0d48a6c1"
import script from "./FontSpecimenVariableElement.vue?vue&type=script&lang=js"
export * from "./FontSpecimenVariableElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/elements/FontSpecimenVariableElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d48a6c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d48a6c1', __exports__)) {
    api.reload('0d48a6c1', __exports__)
  }
  
  module.hot.accept("./FontSpecimenVariableElement.vue?vue&type=template&id=0d48a6c1", () => {
    api.rerender('0d48a6c1', render)
  })

}


export default __exports__